import CreateAssessment from './CreateAssessment';

export default CreateAssessment;
